import React from 'react'
import ReactDOM from 'react-dom/client'
import AppWrapper from './AppWrapper.tsx'
import { captureUTMParams } from './services/adTracking'
import './index.css'
import './styles/shared.css'

// Capture UTM params from ad campaigns on first load
captureUTMParams()

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <AppWrapper />
  </React.StrictMode>,
)
